export enum ProjectStatus {
  Unknown = 0,
  Draft = 1,
  TenderInvitation = 2,
  TenderSent = 3,
  OfferDeclined = 4,
  OfferAccepted = 5,
  Active = 6,
  Finished = 7,
  WarrantyTime = 8,
}
